import * as React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import DashboardLayout from '../../layouts/DashboardLayout';
import ActionsPanel from '../../organisms/ActionsPanel';
import ModalActionDialog from '../../molecules/ModalActionDialog';
import TableWithDynamicCell from '../../organisms/TableWithDynamicCell';
import { franchiseInfoSelector } from '../../redux/ducks/franchiseSettings';
import ModalInfo from '../../molecules/ModalInfo';

import {
  getFranchiseJurisdictionsList,
  updateFranchiseRelations,
  deleteFranchiseJurisdictions,
} from '../../api/franchise';
import tableColumnsFormatter from '../../utils/tableColumnsFormatter';
import useTableWithDynamicCell from '../../hooks/useTableWithDynamicCell';
import { convertTableFranchiseBoolean } from '../../utils/convertTableValues';

const FranchiseConfigurationJurisdictionPage = () => {
  const {
    setSearch,
    handleAdd,
    isModalOpen,
    modalSuccess,
    modalError,
    modalErrorTitle,
    handleCloseModal,
    tableManuallyUpdate,
    search,
    updateTable,
    handleCloseModalInfo,
    setTargetId,
    handleListChange,
    handleCancelUpdate,
    updateDataRequest,
  } = useTableWithDynamicCell<any>({
    deleteAllEndpoint: deleteFranchiseJurisdictions,
    updateEndpoint: updateFranchiseRelations,
    updateTarget: 'connectedJurisdictions',
  });

  const { id, name } = useSelector(franchiseInfoSelector);

  React.useEffect(() => {
    setTargetId(id);
  }, []);

  const columns = column => {
    if (['id'].includes(column)) {
      return null;
    }

    return tableColumnsFormatter(column);
  };

  const handleCloseErrorModal = () => {
    handleCloseModal();
    updateTable();
    handleCloseModalInfo();
  };

  return (
    <DashboardLayout>
      <PageWrapper>
        <ActionsPanel
          onAdd={handleAdd}
          buttonTitle="Save"
          onSearch={setSearch}
          isActionPanelMoreVisible={false}
        />
        <StyledTitle>
          {' '}
          Configure <span>{name}</span> Branch
        </StyledTitle>
      <Container>
        <TableWithDynamicCell
          customSearch
          searchQuery={search}
          rows={getFranchiseJurisdictionsList}
          additionalRequestParams={{ franchiseId: id }}
          columns={columns}
          manuallyUpdate={tableManuallyUpdate}
          handleListChanged={handleListChange}
          onSelectRowHeader="Change status"
          endPositionOfSelectionColumn
          formatValue={convertTableFranchiseBoolean}
          bindingCheckboxesTo={{
            field: 'status',
            value: 'link',
          }}
          initialSortBy={[{ id: 'status', desc: true }]}
        />
      </Container>
      {isModalOpen && (
        <ModalActionDialog
          title="Do you want to save changes?"
          onCancel={handleCloseModal}
          actionFirst={updateDataRequest}
          actionSecond={handleCancelUpdate}
        >
          <p>
            If you don’t save the document, all changes will
            be lost!
          </p>
        </ModalActionDialog>
      )}

      {(modalSuccess || modalError) && (
        <ModalInfo
          timeToClose={5000}
          isError={modalError}
          onClose={handleCloseErrorModal}
          errorMsg={modalErrorTitle}
        />
      )}
      </PageWrapper>
    </DashboardLayout>
  );
};

const PageWrapper = styled.div`
  width: 100%;
  padding: 20px 16px 0;
  box-sizing: border-box;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont,
    'Helvetica Neue', Arial, Roboto, sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';

  @media (max-width: 840px) {
    padding: 12px 12px 0;
  }
`;

const Container = styled.div`
  margin: 20px 0 0 0;
`;

const StyledTitle = styled.p`
  margin: 16px 0 0;
  font-size: 0.875rem;
  color: var(--neutral-600);

  span {
    font-weight: 700;
    color: var(--mainText);
  }
`;

export default FranchiseConfigurationJurisdictionPage;
